import { render } from "./MonitorBanner.vue?vue&type=template&id=70827028&scoped=true"
import script from "./MonitorBanner.vue?vue&type=script&lang=js"
export * from "./MonitorBanner.vue?vue&type=script&lang=js"

import "./MonitorBanner.vue?vue&type=style&index=0&id=70827028&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70827028"]])

export default __exports__